import script from "./UserInfoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./UserInfoCard.vue?vue&type=script&setup=true&lang=js"

import "./UserInfoCard.vue?vue&type=style&index=0&id=b4322bd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4322bd6"]])

export default __exports__